import React from "react";

/**
 * PlayerBadge - Reusable component for displaying player with emoji, colored circle, and name
 * Shows: [emoji in colored circle] [name]
 * Used for consistent player display across the app
 */
const PlayerBadge = ({
  playerName,
  playerColor,
  playerEmoji,
  size = 'medium', // 'small', 'medium', 'large'
  showLabel = true,
  labelPrefix = '', // e.g., "Played by:"
  className = '',
  style = {}
}) => {
  const sizeMap = {
    small: { circle: '20px', icon: '0.9rem', fontSize: '0.75rem', gap: '6px' },
    medium: { circle: '28px', icon: '1rem', fontSize: '0.85rem', gap: '8px' },
    large: { circle: '48px', icon: '2rem', fontSize: '1rem', gap: '10px' }
  };

  const sizes = sizeMap[size] || sizeMap.medium;
  const color = playerColor || '#666666';
  const emoji = playerEmoji || '🎮';

  return (
    <div 
      className={`player-badge ${className}`}
      style={{
        gap: sizes.gap,
        ...style
      }}
    >
      {/* Colored circle with emoji */}
      <div 
        className="player-badge-circle"
        style={{
          width: sizes.circle,
          height: sizes.circle,
          backgroundColor: color,
          fontSize: sizes.icon,
          boxShadow: `0 2px 4px ${color}60`,
          borderColor: color
        }}
      >
        {emoji}
      </div>
      
      {/* Player name */}
      {showLabel && (
        <span 
          className="player-badge-label"
          style={{ 
            fontSize: sizes.fontSize,
          }}
        >
          {labelPrefix && <span className="player-badge-label-prefix">{labelPrefix}</span>}
          {playerName}
        </span>
      )}
    </div>
  );
};

export default PlayerBadge;

